module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_18-51ea1150bb6c39238803f55ff74d607a.jpg";